import React from 'react';

import Modal from 'ui-library/modals/Modal';

import {BoltzGenInputForm} from './boltzgen/BoltzGenInputForm';
import {SCIENTIFIC_MODEL} from './FormConstants';
import StructurePredictionForm from './structure-prediction/StructurePredictionForm';

export interface ScientificModelInputFormProps {
  model: string;
  onRequestClose: () => void;
}

export function ScientificModelInputForm({
  model,
  onRequestClose,
}: ScientificModelInputFormProps): JSX.Element {
  switch (model) {
    case SCIENTIFIC_MODEL.BOLTZGEN:
      return <BoltzGenInputForm onRequestClose={onRequestClose} />;
    case SCIENTIFIC_MODEL.ALPHAFOLD:
    case SCIENTIFIC_MODEL.CHAI1:
    case SCIENTIFIC_MODEL.BOLTZ2:
    case SCIENTIFIC_MODEL.OPENFOLD2:
      return <StructurePredictionForm onSubmit={() => {}} />;
    default:
      throw new Error(`Unsupported model type: ${model}`);
  }
}

export interface ScientificModelInputFormModalProps {
  model: string;
  onRequestClose: () => void;
}

export function ScientificModelInputFormModal({
  model,
  onRequestClose,
}: ScientificModelInputFormModalProps): JSX.Element {
  return (
    <Modal
      title={`Configure ${model}`}
      onRequestClose={onRequestClose}
      closeableOnBackgroundClick={true}
      large={true}
      fullHeight={true}
    >
      <ScientificModelInputForm model={model} onRequestClose={onRequestClose} />
    </Modal>
  );
}
